import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Form, DropdownProps, Statistic, Segment, Label } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";


import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import { GetUser } from "../../services/auth";
import numberFormat from "../../Utils/NumberFormat";
import RegionalManagerRepository, { IRegionalManagerListModel } from "../../Repositories/RegionalManagerRepository";
import SectorManagerRepository, { ISectorManagerListModel } from "../../Repositories/SectorManagerRepository";
import CustomLoader from "../../components/CustomLoader";
import PaymentsConferenceRepository, { IPaymentsConference, IPaymentsParams } from "../../Repositories/PaymentsConferenceRepository";


const PaymentsConference: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IPaymentsConference[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IPaymentsParams>({ year: date.getFullYear().toString(), month: (date.getMonth() + 1).toString(), regionalId: "", sectorId: "" });
    const [regionalManagers, setRegionalManagers] = useState<IRegionalManagerListModel[]>([]);
    const [sectorManagers, setSectorManagers] = useState<ISectorManagerListModel[]>([]);

    const totalEmpresa = list.reduce((a, b) => a + b.valorEmpresa, 0);
    const totalRecebido = list.reduce((a, b) => a + b.valorRecebido, 0);
    const totalRestante = totalRecebido - totalEmpresa;
    const { role } = GetUser();

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2022", value: "2022" },
        { key: "2", text: "2023", value: "2023" },
        { key: "3", text: "2024", value: "2024" },
        { key: "4", text: "2025", value: "2025" },
        { key: "5", text: "2026", value: "2026" },
        { key: "6", text: "2027", value: "2027" },
    ];

    const load = async () => {

        setLoading(true);
        try {

            const response = await PaymentsConferenceRepository.AgentMonth({
                year: state.year,
                month: state.month,
                regionalId: state.regionalId,
                sectorId: state.sectorId
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    useEffect(() => { load() }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const LoadRegionalManagers = useCallback(async () => {
        const result = await RegionalManagerRepository.List({
            filter: "Status == 1"
        });

        setRegionalManagers(result.list);
    }, []);

    useEffect(() => { LoadRegionalManagers() }, [LoadRegionalManagers]);

    const LoadSectorManagers = useCallback(async (id: string) => {
        const result = await SectorManagerRepository.List({
            filter: `GerenteRegionalId == "${id}" && Status == 1`
        });

        setSectorManagers(result.list);
    }, []);


    const onRegionalManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value, sectorId: "", agentId: "" }));
        LoadSectorManagers(value?.toString() || "");
    }

    const onSectorManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value, agentId: "" }));
    }

    const setColor = (valorRecebido: number, valorEmpresa: number) => {
        if ((valorRecebido - valorEmpresa) < 0) {
            return <Label color="red" align="center" size="large" content={numberFormat.Currency((valorRecebido - valorEmpresa))} />
        }
        if ((valorRecebido - valorEmpresa) > 0) {
            return <Label color="green" align="center" size="large" content={numberFormat.Currency((valorRecebido - valorEmpresa))} />
        }
        else {
            return <Label color="grey" align="center" size="large" content={numberFormat.Currency((valorRecebido - valorEmpresa))} />
        }
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Representante",
            content: (x: IPaymentsConference) => x.representante,
            textAlign: "left",
            width: 6
        },
        {
            header: "R$ Empresa",
            content: (x: IPaymentsConference) => numberFormat.Currency(x.valorEmpresa),
            textAlign: "center",
            width: 1
        },
        {
            header: "R$ Recebido",
            content: (x: IPaymentsConference) => numberFormat.Currency(x.valorRecebido),
            textAlign: "center",
            width: 2
        },
        {
            header: "R$ Restante",
            content: (x: IPaymentsConference) => setColor(x.valorRecebido, x.valorEmpresa),
            textAlign: "center",
            width: 2
        }
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Conferência de Entradas`} icon="checkmark" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="regionalId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="G. Regional"
                                                onChange={onRegionalManagerChange}
                                                options={regionalManagers.map(regionalManager => { return { key: regionalManager.id, value: regionalManager.id, text: regionalManager.nome } })}
                                                value={state.regionalId}
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="sectorId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="G. Setor"
                                                onChange={onSectorManagerChange}
                                                options={sectorManagers.map(sectorManager => { return { key: sectorManager.id, value: sectorManager.id, text: sectorManager.nome } })}
                                                value={state.sectorId}
                                                clearable
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment placeholder>
                                    <Grid.Column>
                                        <Statistic.Group size="tiny" widths="3">
                                            <Statistic color="blue">
                                                <Statistic.Value>{numberFormat.Currency(totalEmpresa)}</Statistic.Value>
                                                <Statistic.Label content="Total à Receber"></Statistic.Label>
                                            </Statistic>
                                            <Statistic color="green">
                                                <Statistic.Value>{numberFormat.Currency(totalRecebido)}</Statistic.Value>
                                                <Statistic.Label content="Total Recebido"></Statistic.Label>
                                            </Statistic>
                                            {
                                                totalRestante > 0 ?
                                                    <Statistic color="green">
                                                        <Statistic.Value>{numberFormat.Currency(totalRestante)}</Statistic.Value>
                                                        <Statistic.Label content="Sobrando"></Statistic.Label>
                                                    </Statistic>
                                                    :
                                                    <Statistic color="red">
                                                <Statistic.Value>{numberFormat.Currency(totalRestante)}</Statistic.Value>
                                                <Statistic.Label content="Falta Receber"></Statistic.Label>
                                            </Statistic>
                                            }
                                        </Statistic.Group>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default PaymentsConference;
